import { register, onAppReady } from 'larasnap';
import UploadManagerPanel from './panels/UploadManager';
import { initSiteBannerControl } from './features/SiteBanner';
import { showHelpMenu } from './features/HelpMenu';
import './vue/upload_manager';
import './vue/history_viewer';
import './vue/employee_portal';

register(UploadManagerPanel);

onAppReady(initSiteBannerControl);

window.showHelpMenu = showHelpMenu;

if (process.env.NODE_ENV !== 'production') {
    require('./dev-utility');
}
